import api from '../../lib/api';
import { clearCustomerAuthToken } from './customerAuthToken';

export type CustomerSession = {
  customer_id: number;
  name: string;
  tel: string | null;
  auth_token?: string;
};

export const fetchCurrentCustomerSession = async (): Promise<CustomerSession> => {
  const res = await api.get<CustomerSession>('/api/customer-app/auth/me');
  return res.data;
};

export const logoutCustomerSession = async (): Promise<void> => {
  try {
    await api.post('/api/customer-app/auth/logout');
  } finally {
    clearCustomerAuthToken();
  }
};
